import { indigoA200, orange500 } from "material-ui/styles/colors";

export { indigoA200, orange500 };
